/*
 * PH featured-collection rail — Swiper grab/drag (same vendor as category cards).
 * Mounts on [data-ph-collection-swiper] at all breakpoints. No arrows/pagination.
 * IIFE avoids const collisions with ph-category-swiper.js (shared classic-script scope).
 */
(() => {
  const INSTANCE_KEY = '_phCollectionSwiper';
  const LISTENER_KEY = '__phCollectionSwiperBound';

  function swiperOptions() {
    return {
      slidesPerView: 'auto',
      spaceBetween: 15,
      slidesOffsetBefore: 15,
      slidesOffsetAfter: 15,
      grabCursor: true,
      simulateTouch: true,
      allowTouchMove: true,
      watchOverflow: true,
      resistanceRatio: 0.85,
      observer: true,
      observeParents: true,
      breakpoints: {
        750: {
          spaceBetween: 25,
          slidesOffsetBefore: 50,
          slidesOffsetAfter: 50,
        },
      },
    };
  }

  function destroyRoot(root) {
    if (root[INSTANCE_KEY]) {
      root[INSTANCE_KEY].destroy(true, true);
      root[INSTANCE_KEY] = null;
    }
  }

  function initRoot(root) {
    if (!window.Swiper) return;
    const el = root.querySelector('.swiper');
    if (!el) return;
    destroyRoot(root);
    root[INSTANCE_KEY] = new window.Swiper(el, swiperOptions());
  }

  function initAll(scope) {
    scope.querySelectorAll('[data-ph-collection-swiper]').forEach(initRoot);
  }

  function destroyAll(scope) {
    scope.querySelectorAll('[data-ph-collection-swiper]').forEach(destroyRoot);
  }

  function boot() {
    if (!window.Swiper) {
      window.setTimeout(boot, 50);
      return;
    }
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  if (!window[LISTENER_KEY]) {
    window[LISTENER_KEY] = true;

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target instanceof Element) initAll(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target instanceof Element) destroyAll(event.target);
    });
  }
})();
